import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { BOM_POSITION_API } from "../apiRoutes";

interface mutateProps {
  id: string;
  communityId: string;
}

const mutateDeletePosition = async ({ id, communityId }: mutateProps) => {
  return await axiosAuth.delete(`${BOM_POSITION_API}/community/${communityId}/${id}`);
};

const useDeletePositionMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateDeletePosition,
    ...queryParams,
  });

export default useDeletePositionMutation;
